if (!customElements.get('wonderly-pdp-accordions')) {
  class WonderlyPdpAccordions extends HTMLElement {
    connectedCallback() {
      this.details = [...this.querySelectorAll('details')];

      this.details.forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;

          this.details.forEach((other) => {
            if (other !== detail) other.open = false;
          });
        });
      });
    }
  }

  customElements.define('wonderly-pdp-accordions', WonderlyPdpAccordions);
}
